export const templateLibraryAdminRoutes = {
  default: 'template_library_admin',
  publicContext: 'template_library_public_context',
  public: 'template_library_public',
}
